import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initEventsPin = () => {
	const module = document.querySelector('.events')

	if (!module) return

	const events = module.querySelectorAll('.card-event')
	const container = module.querySelector('.events__inner')

	events.forEach((event, index) => {

		let offset = 0
		const image = event.querySelector('.card-event__image img')
		const height = event.offsetHeight

		if (window.innerWidth < 650 && index === 0) {
			offset = 94
		} else if (window.innerWidth < 650) {
			offset = ((index) * 32) + 94
		} else {
			offset = (index + 1) * 80
		}

		gsap.timeline({
			scrollTrigger: {
				pin: true,
				pinSpacing: false,
				trigger: event,
				endTrigger: '.footer',
				start: `top top+=${offset}px`,
				end: `bottom bottom`,
				scrub: 1
			}
		})

		gsap.to(image, {
			scrollTrigger: {
				trigger: event,
				start: `top top+=${offset}px`,
				end: `+=${height}px`,
				scrub: 1
			},
			width: '284px',
			ease: 'power1.inOut'
		})

	})
}
export default () => {}
